import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const HeroBar = ({ headline, date, navigateTo }) => {
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCurrentImage = async () => {
      try {
        const response = await fetch("https://homchang.in/hero_image.php", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.success && data.heroImages.length > 0) {
          setImageUrl(data.heroImages[0].ImageURL);
        } else {
          console.error("No image found or request failed:", data.message);
        }
      } catch (error) {
        console.error("Error fetching the current image:", error);
      }
    };

    fetchCurrentImage();
  }, []);

  const handleButtonClick = () => {
    if (navigateTo) {
      if (navigateTo.startsWith("http://") || navigateTo.startsWith("https://")) {
        window.open(navigateTo, "_blank", "noopener,noreferrer");
      } else {
        navigate(navigateTo);
      }
    }
  };

  const sectionStyle = {
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <section
      className="text-white py-10 px-6 sm:px-6 lg:px-12 text-start"
      style={sectionStyle}
    >
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4">
        {headline}
      </h2>
      <p className="text-sm sm:text-base lg:text-lg mb-6">
        {date}
      </p>

      {navigateTo && (
        <button
          className="text-white px-4 py-2 rounded-full bg-orange-500 hover:bg-orange-600 transition duration-300 ease-in-out get_button"
          onClick={handleButtonClick}
        >
          Get Registered
        </button>
      )}
    </section>
  );
};

export default HeroBar;
